import { render, staticRenderFns } from "./channelPull.vue?vue&type=template&id=dd5c640e&scoped=true"
import script from "./channelPull.vue?vue&type=script&lang=js"
export * from "./channelPull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5c640e",
  null
  
)

export default component.exports